export function guidePaymentSet(visible, tab) {
	return {
    type: 'GUIDE_PAYMENT_SET',
		payload: {
			visible: visible,
      tab: tab,
		}
	}
}

export function guideApproachMailSet(visible) {
	return {
    type: 'GUIDE_APPROACH_MAIL_SET',
		payload: {
			visible: visible,
		}
	}
}

export function guideAppSet(visible) {
	return {
    type: 'GUIDE_APP_SET',
		payload: {
			visible: visible,
		}
	}
}

export function guideProofPersonSet(visible) {
	return {
    type: 'GUIDE_PROOF_PERSON_SET',
		payload: {
			visible: visible,
		}
	}
}
